<div class="container">
  <ngshop-messages></ngshop-messages>
  <ngshop-header></ngshop-header>
  <router-outlet></router-outlet>
  <ngshop-footer></ngshop-footer>
</div>
